import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import toast, { Toaster } from "react-hot-toast";
import { EyeIcon, EyeOffIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import CreateHealthDetail from "./CreateHealthDeatail";
import { BaseUrl } from "../../BaseUrl";

// This file needs to be removed as it is not in any kind of use.
const CreateHealthOTP = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [showAadhar, setShowAadhar] = useState(false);
  const [resendTime, setResendTime] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [aadharVerified, setAadharVerified] = useState(false);
  const [verifiedAadhar, setVerifiedAadhar] = useState("");

  useEffect(() => {
    if (resendTime > 0 && otpSent) {
      const timer = setTimeout(() => setResendTime(resendTime - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setCanResend(true);
    }
  }, [resendTime, otpSent]);

  const sendOtp = async () => {
    const aadhaarNumber = getValues("aadhar");

    if (!aadhaarNumber || aadhaarNumber.length !== 12) {
      toast.error("Please enter a valid Aadhar number");
      return;
    }

    setOtpSent(true);
    setResendTime(30);
    setCanResend(false);

    try {
      const response = await axios.post(
        `${BaseUrl}/doctor/AadharOTP-Generate`,
        { aadhaarNumber },
        {
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        toast.success("OTP sent successfully!");
      }
    } catch (error) {
      console.error("OTP Sending Failed:", error);
      toast.error("Failed to send OTP. Please try again.");
      setOtpSent(false);
    }
  };

  const verifyOtp = async () => {
    const aadhar = getValues("aadhar");
    const enteredOtp = otp.join("");

    console.log("Aadhar:", aadhar);
    console.log("Entered OTP:", enteredOtp);

    if (!enteredOtp || enteredOtp.length !== 6) {
      toast.error("Please enter the 6-digit OTP");
      return;
    }

    setLoading(true);
    toast.loading("Verifying OTP...", { id: "otp" });

    try {
      const response = await axios.post(
        `${BaseUrl}/doctor/AadharOTP-Verify`,
        {
          aadhar,
          otp: enteredOtp,
        },
        {
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        toast.success(
          "Aadhar verified successfully! Please complete your registration.",
          { id: "otp" }
        );
        setVerifiedAadhar(response.data.data);
        setAadharVerified(true);
      } else {
        toast.error("Invalid OTP. Please try again.", { id: "otp" });
      }
    } catch (error) {
      console.error("OTP Verification Failed:", error);
      toast.error("Invalid OTP. Please try again.", { id: "otp" });
    } finally {
      setLoading(false);
    }
  };

  const handleOtpChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    } else if (!value && index > 0) {
      document.getElementById(`otp-${index - 1}`)?.focus();
    }
  };

  if (aadharVerified == false) {
    return <CreateHealthDetail aadhar={verifiedAadhar} />;
  }

  return (
    <div className='flex items-center justify-center bg-gray-100 px-4'>
      <Toaster position='top-center' />
      <div className='my-5 w-full max-w-6xl rounded-lg bg-white p-12 shadow-lg'>
        <h2 className='mb-6 text-3xl font-semibold'>
          Create Your Healthcare Professional ID
        </h2>

        <form className='space-y-6'>
          <div className='relative'>
            <p className='mt-2 text-lg font-medium text-gray-600'>
              Enter Your Aadhar Number/Virtual ID
            </p>
            <div className='relative mt-1'>
              <input
                type={showAadhar ? "text" : "password"}
                className='w-full rounded-lg border px-4 py-3 text-lg focus:border-blue-400 focus:ring-2 focus:ring-blue-400'
                {...register("aadhar", {
                  required: true,
                  minLength: 12,
                  maxLength: 12,
                })}
              />
              <button
                type='button'
                className='absolute right-3 top-1/2 -translate-y-1/2 transform text-gray-500'
                onClick={() => setShowAadhar(!showAadhar)}
              >
                {showAadhar ? <EyeOffIcon size={24} /> : <EyeIcon size={24} />}
              </button>
            </div>
            {errors.aadhar && (
              <p className='mt-1 text-sm text-red-500'>
                Aadhar number is required.
              </p>
            )}
          </div>

          {!otpSent && (
            <div className='mt-2 flex justify-center'>
              <button
                type='button'
                className='w-1/2 rounded-lg bg-blue-500 py-3 text-lg font-semibold text-white transition-all hover:bg-blue-600'
                onClick={sendOtp}
              >
                Send OTP
              </button>
            </div>
          )}

          {otpSent && (
            <>
              <p className='font-small mt-2 text-lg text-gray-600'>
                We have sent an OTP to your Aadhaar-linked mobile.
              </p>

              <div className='mt-1 flex space-x-2'>
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-${index}`}
                    type='text'
                    maxLength='1'
                    value={digit}
                    className='h-12 w-16 rounded-lg border text-center text-2xl focus:border-blue-400 focus:ring-2 focus:ring-blue-400'
                    onChange={(e) => handleOtpChange(index, e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace" && !otp[index] && index > 0) {
                        document.getElementById(`otp-${index - 1}`)?.focus();
                      }
                    }}
                  />
                ))}
              </div>

              <div className='mt-1 text-lg text-gray-600'>
                Didn't receive OTP?{" "}
                {canResend ? (
                  <span
                    className='cursor-pointer text-blue-500'
                    onClick={sendOtp}
                  >
                    Resend OTP
                  </span>
                ) : (
                  <span className='text-gray-400'>
                    Resend OTP in {resendTime}s
                  </span>
                )}
              </div>

              <div className='mt-2 flex justify-center'>
                <button
                  type='button'
                  disabled={loading}
                  className='w-1/2 rounded-lg bg-blue-500 py-3 text-lg font-semibold text-white transition-all hover:bg-blue-600'
                  onClick={verifyOtp}
                >
                  {loading ? "Verifying..." : "Submit"}
                </button>
              </div>
            </>
          )}

          <p className='text-center text-lg text-gray-700'>
            Already have an account?{" "}
            <span
              onClick={() => navigate("/")}
              className='cursor-pointer text-blue-500'
            >
              Login Here
            </span>
          </p>
        </form>
      </div>
    </div>
  );
};

export default CreateHealthOTP;
